import React, { useEffect, useState, useLayoutEffect } from "react";
import Layout from "../../../components/mobile/Layout/layoutmobileempty";
import {getLandingDetail} from '../../../service/landingService';
import {Cover_Layout_1, Cover_Layout_2} from '../../../components/mobile/Landing/Cover';
import {Video_Layout_1, Video_Layout_2} from '../../../components/mobile/Landing/Video_Cover';
import {Banner_Layout_1, Banner_Layout_2} from '../../../components/mobile/Landing/Banner';
import {Menu_Layout_1, Menu_Layout_2, Menu_Layout_3} from '../../../components/mobile/Landing/Menu';
import {Image_Layout_1, Image_Layout_2, Image_Layout_3} from '../../../components/mobile/Landing/Images';
import {Product_Layout_1, Product_Layout_2,Product_Layout_3,
    Product_Layout_4, Product_Layout_5,Product_Layout_6,
    Product_Layout_7, Product_Layout_8,Product_Layout_9,
    Product_Layout_10, Product_Layout_11,Product_Layout_12
} from '../../../components/mobile/Landing/Product';
import { useLocation } from '@reach/router';
import { getUrlShare } from "../../../service/campaignService";
import platform from 'platform';
import {pushtracking} from '../../../service/trackingService';
import { isAuth } from "../../../helpers/general";
import { toast } from "react-toastify";
import { Share } from '@capacitor/share';
// import Head from "../../../components/Head";
import ReactHtmlParser from 'react-html-parser';

import './css/landing.css';
const Landing=()=>{
    const location = useLocation();
    let _uri = location.pathname;
    const [dataLanding, setDataLanding] = useState([]);
    const getDataLanding=(id)=>{
        getLandingDetail(id).then((response)=>{
            if(+response.status === 200){
                setDataLanding(response.message);
            }
        })
    }
    const [showShare, setShowShare] = useState(false);
    const [urlShare, setUrlShare] = useState('');
    const getDataUrlShare=(id)=>{
        if(isAuth() === true){
            const param ={
                "type": "1",
                "user": window.localStorage.getItem('_id'),
                "parameter": "id="+id
            }
            getUrlShare(param).then((response)=>{
                if(response.status === 200){
                    Share.share({
                        title: dataLanding[0]?.title,
                        text: dataLanding[0]?.title,
                        url: response.message,
                        dialogTitle: response.message,
                    });
                }
            })
            
        }else{
            toast.warning('Bạn cần đăng nhập để sử dụng chức năng này.');
        }
        
    }
    const [scrollPosition, setPosition] = useState(0);
    useLayoutEffect(() => {
        function updatePosition() {
          setPosition(window.pageYOffset);
          window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);
    }, []);

    const [operatingSystem, setOperatingSystem] = useState('Windows');
    const getOS = ()=> {
        var uA = navigator.userAgent || navigator.vendor || window.opera;
        if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) 
        { setOperatingSystem('iOS');}
      
        var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
        for (i = 0; i < os.length; i++) if (new RegExp(os[i],'i').test(uA)) {
            setOperatingSystem(os[i]);
        }     
    }
    const [uri, setUri] = useState();
    const [meta, setMeta] = useState();
    useEffect(()=>{
        getOS();
        let uri = location.search?.replace('?','').replace('=','');
        setUri(uri);
        window.localStorage.removeItem('nameCategory');
        getDataLanding(uri);

        var pageView = sessionStorage.getItem("pageViewLanding");
            if (pageView == null) {
                setTimeout(() => {
                    try{
                        if(platform.product !== 'iPhone'){
                            let _link = "bibomart://landing-page?id="+uri+"&idShare="+window.localStorage.getItem('idShare');
                            window.location.replace(_link);
                        }
                    }catch(e){}
                }, 1000); 
                pageView = 1;
            } 
            sessionStorage.setItem("pageViewLanding", pageView);

            try{
                pushtracking(window.localStorage.getItem('sessionId')??null,
                window.localStorage.getItem('_id')??null,
                window.localStorage.getItem('phone')??null ,
                _uri, "Landing page", 0,0,'index','inWeb',[],'Website Mobile').then((response)=>{
                    // console.log('send tracking');
                });
            }catch(e){console.log(e)}
setMeta({
        "meta_title": dataLanding[0]?.title,
        "meta_keyword": ReactHtmlParser(dataLanding[0]?.description),
        "meta_description": "",
        "meta_url": window.location.href,
        "meta_site": window.location.host,
        "meta_img":""
    });
    },[])
    const handleBack=()=>{
        window.history.back();
    } 
    const handleShare=()=>{
        getDataUrlShare(uri);
    }
    const handandleRedirect = (uri) => {
        window.location.replace(uri);
    }
    const [count_cart, setCountCart] = useState(0);
   const call = setInterval(() => {
        if (localStorage.getItem('key') !== null && localStorage.getItem('itemsCart') !== null && localStorage.getItem('itemsCart') !== "Yêu cầu không hợp lệ") {
            let _count = JSON.parse(localStorage.getItem('itemsCart'));
            setCountCart(_count?.length);
            clearInterval(call);
        }
    }, 10000);
    if(dataLanding.length > 0 ){
    return(
        <Layout>
            {/* <Head key="Head" item={meta}/> */}
            <h1 className="d-none">{dataLanding[0]?.title}</h1>
            <div className={scrollPosition > 35 ?("fixed"):("")}>
                <div className="row header-product-main pdy-10 mgx-0 pdx-10">
                    <div onClick={handleBack}  className="col-2 header-left pdl-10">
                        <i className="fa-solid fa-chevron-left"></i>
                    </div>
                    <div className="col-7 header-center in-f pdx-0">
                        <span>{dataLanding.length > 0?(dataLanding[0]?.title):(null)}</span>
                    </div>
                    <div className="col-3 in-jus pdx-0">
                        <div className="cart-header">
                            <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon"/>
                            <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                        </div>
                        <img onClick={()=>handandleRedirect('/')} src="/../images/account/home.svg" alt="icon"/>
                        <img onClick={handleShare}  src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share_black.png" alt="icon"/>
                    </div>
                    </div>
                </div>
                <div className="landing-page" id="landing-page">
                    {
                        dataLanding.map((item,i)=>{
                            return <>
                                {
                                (() => { switch(item.pageLanding.code){
                                    case 'Cover':
                                        return  (() => { switch(item.pageLanding.value){
                                            case 'Layout_1':
                                                return <Cover_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_2':
                                                return <Cover_Layout_2 key={i} item={item.pageLanding?.images}/>
                                            default:
                                                return <Cover_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            }
                                        })()
                                    case 'Video_Cover':
                                        return  (() => { switch(item.pageLanding.value){
                                            case 'Layout_1':
                                                return  <Video_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_2':
                                                return  <Video_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            default:
                                                return  <Video_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            }
                                        })()
                                    case 'Banner':
                                        return  (() => { switch(item.pageLanding.value){
                                            case 'Layout_1':
                                                return  <Banner_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_2':
                                                return  <Banner_Layout_2 key={i} item={item.pageLanding?.images}/>
                                            default:
                                                return  <Banner_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            }
                                        })()
                                    case 'Menu':
                                        return  (() => { switch(item.pageLanding.value){
                                            case 'Layout_1':
                                                return  <Menu_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_2':
                                                return  <Menu_Layout_2 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_3':
                                                return  <Menu_Layout_3 key={i} item={item.pageLanding?.images}/>
                                            default:
                                                return  <Menu_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            }
                                        })()
                                    case 'Images':
                                        return  (() => { switch(item.pageLanding.value){
                                            case 'Layout_1':
                                                return  <Image_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_2':
                                                return  <Image_Layout_2 key={i} item={item.pageLanding?.images}/>
                                            case 'Layout_3':
                                                return  <Image_Layout_3 key={i} item={item.pageLanding?.images}/>
                                            default:
                                                return  <Image_Layout_1 key={i} item={item.pageLanding?.images}/>
                                            }
                                        })()
                                    case 'Product':
                                        return  (() => { switch(item.pageLanding.value){
                                            case 'Layout_1':
                                                    return  (() => { switch(item.pageLanding.type_producst){
                                                        case 'HOTDEAL':
                                                            return  <Product_Layout_8 key={i} item={item.pageLanding?.producst}/>
                                                        case 'MUAHANGTANGHANG':
                                                            return  <Product_Layout_9 key={i} item={item.pageLanding?.producst}/>
                                                        default:
                                                            return  <Product_Layout_7 key={i} item={item.pageLanding?.producst}/>
                                                        }
                                                    })()
                                            case 'Layout_2':
                                                return  (() => { switch(item.pageLanding.type_producst){
                                                    case 'HOTDEAL':
                                                        return  <Product_Layout_11 key={i} item={item.pageLanding?.producst}/>
                                                    case 'MUAHANGTANGHANG':
                                                        return  <Product_Layout_12 key={i} item={item.pageLanding?.producst}/>
                                                    default:
                                                        return  <Product_Layout_10 key={i} item={item.pageLanding?.producst}/>
                                                    }
                                                })()
                                            case 'Layout_3':
                                                return  (() => { switch(item.pageLanding.type_producst){
                                                    case 'HOTDEAL':
                                                        return  <Product_Layout_8 key={i} item={item.pageLanding?.producst}/>
                                                    case 'MUAHANGTANGHANG':
                                                        return  <Product_Layout_9 key={i} item={item.pageLanding?.producst}/>
                                                    default:
                                                        return  <Product_Layout_7 key={i} item={item.pageLanding?.producst}/>
                                                    }
                                                })()
                                            case 'Layout_4':
                                                    return  (() => { switch(item.pageLanding.type_producst){
                                                        case 'HOTDEAL':
                                                            return  <Product_Layout_4 key={i} item={item.pageLanding?.producst}/>
                                                        case 'MUAHANGTANGHANG':
                                                            return  <Product_Layout_5 key={i} item={item.pageLanding?.producst}/>
                                                        default:
                                                            return  <Product_Layout_6 key={i} item={item.pageLanding?.producst}/>
                                                        }
                                                    })()
                                            case 'Layout_5':
                                                return  (() => { switch(item.pageLanding.type_producst){
                                                    case 'HOTDEAL':
                                                        return  <Product_Layout_2 key={i} item={item.pageLanding?.producst}/>
                                                    case 'MUAHANGTANGHANG':
                                                        return  <Product_Layout_3 key={i} item={item.pageLanding?.producst}/>
                                                    default:
                                                        return  <Product_Layout_1 key={i} item={item.pageLanding?.producst}/>
                                                    }
                                                })()
                                            case 'Layout_6':
                                                    return  (() => { switch(item.pageLanding.type_producst){
                                                        case 'HOTDEAL':
                                                            return  <Product_Layout_4 key={i} item={item.pageLanding?.producst}/>
                                                        case 'MUAHANGTANGHANG':
                                                            return  <Product_Layout_5 key={i} item={item.pageLanding?.producst}/>
                                                        default:
                                                            return  <Product_Layout_6 key={i} item={item.pageLanding?.producst}/>
                                                        }
                                                    })()
                                            default:
                                                return  (() => { switch(item.pageLanding.type_producst){
                                                    case 'HOTDEAL':
                                                        return  <Product_Layout_2 key={i} item={item.pageLanding?.producst}/>
                                                    case 'MUAHANGTANGHANG':
                                                        return  <Product_Layout_3 key={i} item={item.pageLanding?.producst}/>
                                                    default:
                                                        return  <Product_Layout_1 key={i} item={item.pageLanding?.producst}/>
                                                    }
                                                })()
                                            }
                                        })()
                                    default:
                                        <></>
                                    }
                                })()
                                }
                            </>
                        })
                    }
                </div>

        </Layout>
    ) 
    }else{
        return <Layout><div className="loading-page-app-item" style={{textAlign:"center"}}>
            <img src="/../images/loading.gif" alt="icon"/>
            </div></Layout>
    }
}
export default Landing;